import { Row, Col, Button } from "react-bootstrap";
import { Device } from "types";

type ChartListProps = {
    sensorList: Device[] | null;
    onChange: (newSensors: any[]) => void;
};
const ChartList = ({ sensorList, onChange }: ChartListProps) => {
    const sensors = [...(sensorList || [])];

    const removeSensor = (sensor: Device) => {
        const newSensors = sensors.filter(
            (item) => item.deviceId !== sensor.deviceId
        );
        if (typeof onChange === "function") {
            onChange(newSensors);
        }
    };

    return (
        <Row className="cstm-table heatmap-sensor-table mt-4">
            <Col sm={12}>
                {sensors?.length ? (
                    <div className="table-head">
                        <Row className="no-checkbox">
                            <Col xs={{ span: 3 }}>Sensor</Col>
                            <Col xs={{ span: 3 }}>Type</Col>
                            <Col xs={{ span: 3 }}>Gateway</Col>
                            <Col xs={{ span: 2 }}>UUID</Col>
                            <Col xs={{ span: 1 }}> </Col>
                        </Row>
                    </div>
                ) : (
                    ""
                )}

                {sensors.map((sensor: any) => (
                    <div className="table-row" key={sensor.ldsuUID}>
                        <Row className="no-checkbox">
                            <Col xs={{ span: 3 }}>{sensor.sensorName}</Col>
                            <Col xs={{ span: 3 }}>{sensor.sensorType}</Col>
                            <Col md={{ span: 3 }}>{sensor.gatewayName}</Col>
                            <Col md={{ span: 2 }}>{sensor.ldsuUID}</Col>
                            <Col md={{ span: 1 }} className="text-right">
                                <Button
                                    variant="link"
                                    onClick={() => removeSensor(sensor)}
                                    className="p-0 text-decoration-none"
                                >
                                    <i className="material-icons close-icon d-flex">
                                        close
                                    </i>
                                </Button>
                            </Col>
                        </Row>
                    </div>
                ))}
            </Col>
        </Row>
    );
};

export default ChartList;
